import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationGroupApi } from '../../api/lib/destination-group';
import { destinationGroupsKeys } from '../../api/query-keys/destination-groups';
import { DestinationGroup } from '../../api/types/destination-group';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useDestinationGroups = ({
  page,
  perPage,
  enabled,
}: {
  page: number;
  perPage: number;
  enabled?: boolean;
}) => {
  return useQuery<PaginatedResponse<DestinationGroup>, ApiError>({
    queryKey: destinationGroupsKeys.list(page, perPage),
    queryFn: () => destinationGroupApi.fetchDestinationGroups(page, perPage),
    enabled,
  });
};
